module.exports = __webpack_public_path__ + "img/pennellata-top.95fbd1de.jpg";